import { Directive, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Util } from '@libs/utilities/util';
import { distinctUntilChanged, Subject } from 'rxjs';


@Directive({
    selector: '[ngScroll]',
    standalone: false
})
export class NgScrollDirective implements OnInit {

	//** Decorators */
	@Input() elementScroll	: boolean = true;
	@Input() documentScroll	: boolean = true;
	@Input() windowScroll	: boolean = true;
	@Output() readonly ngScroll: EventEmitter<Event> = new EventEmitter<Event>();

	//** Helper variable */
	private scrollDetector: Subject<Event> = new Subject<Event>();


	ngOnInit(): void {
		this.scrollDetector.pipe(distinctUntilChanged()).subscribe((event: Event) => { this.ngScroll.emit(event); });
	}


	/**------------------------------------------------------
	 * Scroll Event Listeners
	 */
	@HostListener('window:scroll', ['$event'])
	onWindowScroll(event: Event): void {
		if (Util.Boolean.isTrue(this.windowScroll)) this.scrollDetector.next(event);
	}

	@HostListener('document:scroll', ['$event'])
	onDocumentScroll(event: Event): void {
		if (Util.Boolean.isTrue(this.documentScroll)) this.scrollDetector.next(event);
	}

	@HostListener('scroll', ['$event'])
	onElementScroll(event: Event): void {
		if (Util.Boolean.isTrue(this.elementScroll)) this.scrollDetector.next(event);
	}
}
